import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const AutorizacionEvaluacionesListaPrint = () => {
  const tituloFormulario =
    "AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE PRUEBAS DE CONFIANZA";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, reset } = useForm();

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        fecha_inasistencia: fechafg.fecha_inasistencia || "",
      });
    }
  }, [queryFechaFG.data, reset]);

  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative">
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>

      {/* Contenido del formulario */}
      <div className="p-6">
        <div className="space-y-6">
          <div className="flex items-center space-x-2 mb-4">
            <p className="mt-1 translate-y-1 whitespace-nowrap">
              Ciudad de México a{" "}
              {queryFechaFG.data?.fecha_autorizacion_procesoevaluaciones
                ? (() => {
                    const date = new Date(
                      queryFechaFG.data.fecha_autorizacion_procesoevaluaciones
                    );
                    date.setDate(date.getDate() + 1);
                    return date.toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    });
                  })()
                : "Fecha no disponible"}
            </p>
          </div>
          <p className="text-justify text-gray-800 leading-relaxed">
            <span className="mr-2">Yo{""}</span>
            {`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}{" "}
            autorizo que me apliquen todas las evaluacionesde Pruebas de
            confianza que consisten en:{" "}
          </p>

          <ol className="list-decimal pl-5 text-justify text-gray-800 leading-relaxed space-y-2">
            <li>
              <strong>Evaluación Médica:</strong> Revisión, valoración,
              cuestionarios, historia clínica, entrevista, etc.
            </li>
            <li>
              <strong>Evaluación Psicológica:</strong> Aplicación de pruebas
              psicológicas y entrevista.
            </li>
            <li>
              <strong>Evaluación Poligráfica:</strong> Entrevista y examen
              poligráfico de ser el caso.
            </li>
            <li>
              <strong>Evaluación de Visita Domiciliaria:</strong> Visita al
              domicilio del evaluado, entrevista a evaluado, vecinos y
              familiares.
            </li>
            <li>
              <strong>Evaluación Toxicológica:</strong> Recolección de muestra
              para realizar reactivo de 6 elementos.
            </li>
            <li>
              <strong>
                Evaluación de Pruebas Socioeconómicas y/o Patrimonial:
              </strong>{" "}
              Así como visita domiciliaria en caso de ser necesario.
            </li>
          </ol>

          <p className="text-justify">
            <strong>VERIFICACIÓN DOCUMENTAL:</strong> Entrega de documentos
            necesarios para la conformación del expediente; así como la
            validación de documentos.
          </p>

          <p className="text-justify">
            <strong>INVESTIGACIÓN ANTECEDENTES:</strong> Verificación de
            antecedentes registrales de tipo penal, administrativo, laboral,
            patrimonial, económico y de referencias; mediante la utilización de
            sistemas automatizados de identificación, fuentes abiertas, públicas
            y oficiales, así como, la consulta en bases estatales y federales, y
            la investigación específica ante instituciones competentes de los
            tres niveles de gobierno que puedan proporcionar información de los
            antecedentes referidos. En su caso grabado de voz, toma de
            fotografía y huellas decadactilares.
          </p>

          <p className="text-justify">
            <strong>PRUEBAS SOCIOECONÓMICA Y/O PATRIMONIALES:</strong> Llenado
            de cuestionarios, entrevista si el caso lo amerita, indagar sobre el
            ambiente social, familiar, nivel de vida, trayectoria académica,
            laboral, profesional y visita domiciliaria.
          </p>

          <p className="text-justify">
            Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
            C.V. para que proporcione toda la información y documentación que
            derive de las evaluaciones de pruebas de confianza que me realicen.
          </p>

          <p className="text-justify">
            En este acto autorizo y conozco el aviso de privacidad el cual se
            encuentra publicado en
            https://skyangel.com.mx/avisodeprivacidad.htim, por lo cual en este
            acto consiento que SKA TRACKING AND SECURITY S.A. de C.V. podrá
            recabar mis datos personales de conformidad con los términos
            establecidos en dicho aviso.
          </p>

          <p className="text-justify">
            Bajo protesta de decir verdad hago constar que los datos
            proporcionados en el proceso de evaluación son verdaderos.
          </p>
        </div>

        <div className="flex flex-col items-center mt-4 w-full">
          <span className="font-medium text-center mb-12">ATENTAMENTE</span>
          <div className="w-64 border-b-2 border-gray-800" />
          <span className="text-center font-semibold mt-2">NOMBRE Y FIRMA</span>
        </div>
        <br />
        <br />
      </div>

      <div className="mt-[500px]"></div>

      {/* Footer */}
      <div className="bg-customBlue/90 py-2 rounded-b-lg w-full">
        <p className="text-white text-xs text-center font-light px-4">
          <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
          Prohibida su reproducción o copia fuera de las instalaciones de
          Skyangel.
        </p>
      </div>
    </div>
  );
};
